// extracted by mini-css-extract-plugin
export default {"wrap":"ChatInput_wrap__OkkUC","input":"ChatInput_input__Mc17O","sendDisabled":"ChatInput_sendDisabled__33Wpv","send":"ChatInput_send__PZUa4"};